The additional `HiringOrganization`-specific criteria to filter by.
